module.exports = __webpack_public_path__ + "static/katarzyna-gawronska-medinvest-c8a303d1f97998f7f98ec7aa48c46857.jpg";